import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Front-End-Developer",
          "Open Source Contributor",
          "Good Heart + Passion + Dedication + Positiveness + Patience = Success .”"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
}

export default Type;
